import { render, staticRenderFns } from "./ReceiptsClient.vue?vue&type=template&id=84016188&scoped=true&"
import script from "./ReceiptsClient.vue?vue&type=script&lang=ts&"
export * from "./ReceiptsClient.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84016188",
  null
  
)

export default component.exports